// src/design/forms/datepicker/calendar-engine/use-cases/nepali_date/previous_month.ts
var e = (e) => e.bsMonth - 1 == 0 ? 12 : e.bsMonth - 1;
export { e as previous_month };

//# sourceMappingURL=previous_month.js.map